/**
 * Created by aaikepae on 2/12/17.
 */
import React from "react";
import {generateInfoCard, generate} from "Common/utility/infoCard";

export default class BlogItem extends React.Component {
  render() {
    const {data} = this.props;

    if (!data) {
      return ""
    }

    const elements = generateInfoCard(data, this.props.type);
    return (
      <div className="row">
        <div className="col-md-3 hidden-sm-down">
          <span data-track-name="blog:item:image"
                data-track-value={data.title} >
            {elements.image}
          </span>

        </div>
        <div className="col-md-9 col-sm-12">
           <span data-track-name="blog:item:title"
                 data-track-value={data.title} >
          {elements.title}
           </span>
          {elements.subtitle}
          {elements.description}
          <span data-track-name="blog:item:readmore"
                data-track-value={data.title} >
          {elements.link}
          </span>
        </div>
      </div>
    )
  }
}
